<template>
   <div class="msg-rtc"
   :class="{
    'mine':data.mine,
    'call-over': !data.mine && data.content.uint32_video_status_type === 2,
    'isMobile': isMobile
    }"
    @contextmenu.prevent="onContextMenu"
    :title="formatTime"
    >
       <span v-if="!data.mine" class="icon" :class="{'audio': data.content.uint32_call_type === 2}"></span>
       <span>{{processedText}}</span>
       <span v-if="data.mine" class="icon icon-right" :class="{'audio': data.content.uint32_call_type === 2}"></span>
    </div>
</template>

<script>

export default {
  inject: [],
  props: {
    data: Object,
  },
  data() {
    return {

    };
  },
  computed: {
    processedText() {
      return this.data.content.str_text_msg;
    },
    formatTime() {
      const date = new Date(this.data.time);
      return date.toLocaleString();
    },
    isMobile() {
      return !this.$platform.pc;
    },
  },
  mounted() {
    // console.log(this.data)
  },
  methods: {
    onContextMenu() {
    },
  },
};
</script>

<style lang="less">
.msg-rtc{
    position: relative;
    vertical-align: middle;
    box-sizing: border-box;
    padding: 9px 12px;
    background: #F3F5FA;
    border-radius: 2px 6px 6px 6px;
    color: #F75559;
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
    text-align: left;
    font-size: 14px;
    span{
        user-select: text;
        -webkit-user-select: text;
        line-height: 22px;
    }
    .icon{
        display: inline-block;
        height: 14px;
        width: 18px;
        margin-right: 8px;
        vertical-align: -2px;
        background-size: 100%;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3Csvg width='19' height='16' viewBox='0 0 19 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 3.592C0 2.58 0 2.074.197 1.687c.174-.34.45-.617.791-.79C1.375.7 1.882.7 2.895.7h9.59c1.014 0 1.52 0 1.908.197.34.173.617.45.79.79.198.387.198.893.198 1.905v1.326l2.5-1.666c.36-.239.54-.359.689-.351.135.006.26.073.341.182.089.12.089.336.089.767v8.16c0 .432 0 .648-.089.768a.453.453 0 0 1-.341.182c-.15.008-.329-.112-.688-.351l-2.501-1.666v1.326c0 1.012 0 1.518-.197 1.905-.174.34-.45.617-.791.79-.387.197-.894.197-1.907.197h-9.59c-1.014 0-1.52 0-1.908-.197a1.809 1.809 0 0 1-.79-.79C0 13.787 0 13.281 0 12.27V3.592zM3.167 5.22a1.356 1.356 0 1 0 .001-2.713 1.356 1.356 0 0 0-.001 2.713z' fill='%23F75559'/%3E%3C/svg%3E");
        &.audio{
            height: 16px;
            width: 16px;
            background-image: url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M2.352.863a1.204 1.204 0 0 1 1.841.141l2.763 3.869c.372.52.272 1.24-.227 1.64l-1.024.818c.063.148.16.349.301.598.343.6.955 1.478 2.021 2.544 1.066 1.066 1.945 1.678 2.544 2.02.25.143.45.239.598.302l.819-1.024c.399-.5 1.119-.6 1.64-.228l3.868 2.764c.61.436.678 1.317.141 1.84l-1.551 1.515c-.62.605-1.499.982-2.425.786-1.702-.36-4.928-1.5-8.518-5.09C1.553 9.766.413 6.54.053 4.838c-.197-.926.18-1.805.785-2.425L2.352.863z' fill='%23F75559'/%3E%3C/svg%3E");
        }
        &.icon-right {
          margin-left: 8px;
          margin-right: 0;
          vertical-align: -1px;
        }
    }
    &.call-over{
        color: #262D3D;
        .icon {
            background-image: url("data:image/svg+xml,%3Csvg width='19' height='14' viewBox='0 0 19 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M.667 3c0-.933 0-1.4.181-1.757.16-.313.415-.568.729-.728C1.933.333 2.4.333 3.333.333h8.834c.933 0 1.4 0 1.756.182.314.16.569.415.729.728.181.357.181.824.181 1.757v1.222l2.304-1.535c.33-.221.496-.331.633-.325.125.006.24.068.315.169.082.11.082.31.082.707v7.524c0 .398 0 .597-.082.707a.417.417 0 0 1-.315.169c-.137.006-.302-.104-.633-.325l-2.304-1.535V11c0 .933 0 1.4-.181 1.757-.16.313-.415.568-.729.728-.356.182-.823.182-1.756.182H3.333c-.933 0-1.4 0-1.756-.182a1.666 1.666 0 0 1-.729-.728C.667 12.4.667 11.933.667 11V3zm2.916 1.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z' fill='%23262D3D'/%3E%3C/svg%3E");
            &.audio{
                background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.595.42a1.023 1.023 0 0 1 1.564.12l2.347 3.286c.316.442.231 1.054-.193 1.393l-.87.696c.054.125.135.296.256.508.291.509.811 1.255 1.717 2.161.906.906 1.652 1.426 2.161 1.717.212.12.383.202.508.256l.696-.87c.34-.424.95-.51 1.393-.193l3.287 2.347c.518.37.576 1.12.12 1.565l-1.318 1.286c-.527.514-1.273.834-2.06.668-1.446-.306-4.187-1.275-7.238-4.325C1.915 7.985.947 5.243.641 3.798c-.167-.788.153-1.534.667-2.06L2.595.418z' fill='%23262D3D'/%3E%3C/svg%3E");
            }
        }
    }

    &.mine{
        color: #fff;
        background: #4A70FF;
        border-radius: 6px 2px 6px 6px;
        .icon {
            background-image: url("./assets/video.svg");
            &.audio{
                background-image: url("./assets/audio.svg");
            }
        }
    }
}
.msg-rtc.isMobile {
  background: #fff;
  &.mine{
    background: #4A70FF;
  }
}
</style>
